define("preview-grid/templates/application", ["exports", "@ember/template-factory"], function (_exports, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars"eaimeta@70e063a35619d71f

  var _default = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="cCA--boardWrapper">
    <div class="cCA--board fc fc-direction-ltr">
      <Shared::ContextNav @useExternalLinks={{true}}>
        <:leftSide>
          {{#unless this.numOverPostLimit}}
            <div class="fc-toolbar-chunk">
              <span class="u--m__l__sm">{{t "preview_grid.preview_ig_only"}}</span>
            </div>
          {{/unless}}
        </:leftSide>
      </Shared::ContextNav>
      <Main
        @canSave={{this.canSave}}
        @droppedElements={{action "droppedElements"}}
        @enableAutoSchedule={{this.enableAutoSchedule}}
        @errors={{this.errorList}}
        @existingPosts={{this.activePosts}}
        @hasTimeSlots={{this.hasTimeSlots}}
        @igPosts={{this.igPosts}}
        @igUser={{this.igUser}}
        @isDragging={{this.isDragging}}
        @isSaving={{this.isSaving}}
        @makeSharePlan={{perform this.makeSharePlan}}
        @previewPosts={{this.previewPosts}}
        @removeNewPreviewPost={{action "removeNewPreviewPost"}}
        @revertChanges={{action "revertChanges"}}
        @saveChanges={{action "saveChanges"}}
        @showQuickScheduleWizard={{action "showQuickScheduleWizard"}}
        @socialProfile={{this.socialProfile}}
      />
    </div>
  </div>
  
  <SharePlanModal
    @closeModal={{set this "sharePlan" null}}
    @errorMessage={{this.errorMessage}}
    @sharePlan={{this.sharePlan}}
  />
  
  <SharePlanUpgradeModal
    @closeModal={{set this "showSharePlanUpgradeModal" false}}
    @currentAccount={{this.auth.currentAccount}}
    @showUpgradeModal={{this.shouldShowUpgradeModal}}
  />
  
  {{outlet}}
  */
  {
    "id": "RroOjoXx",
    "block": "[[[10,0],[14,0,\"cCA--boardWrapper\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"cCA--board fc fc-direction-ltr\"],[12],[1,\"\\n    \"],[8,[39,0],null,[[\"@useExternalLinks\"],[true]],[[\"leftSide\"],[[[[1,\"\\n\"],[41,[51,[30,0,[\"numOverPostLimit\"]]],[[[1,\"          \"],[10,0],[14,0,\"fc-toolbar-chunk\"],[12],[1,\"\\n            \"],[10,1],[14,0,\"u--m__l__sm\"],[12],[1,[28,[35,2],[\"preview_grid.preview_ig_only\"],null]],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[1,\"      \"]],[]]]]],[1,\"\\n    \"],[8,[39,3],null,[[\"@canSave\",\"@droppedElements\",\"@enableAutoSchedule\",\"@errors\",\"@existingPosts\",\"@hasTimeSlots\",\"@igPosts\",\"@igUser\",\"@isDragging\",\"@isSaving\",\"@makeSharePlan\",\"@previewPosts\",\"@removeNewPreviewPost\",\"@revertChanges\",\"@saveChanges\",\"@showQuickScheduleWizard\",\"@socialProfile\"],[[30,0,[\"canSave\"]],[28,[37,4],[[30,0],\"droppedElements\"],null],[30,0,[\"enableAutoSchedule\"]],[30,0,[\"errorList\"]],[30,0,[\"activePosts\"]],[30,0,[\"hasTimeSlots\"]],[30,0,[\"igPosts\"]],[30,0,[\"igUser\"]],[30,0,[\"isDragging\"]],[30,0,[\"isSaving\"]],[28,[37,5],[[30,0,[\"makeSharePlan\"]]],null],[30,0,[\"previewPosts\"]],[28,[37,4],[[30,0],\"removeNewPreviewPost\"],null],[28,[37,4],[[30,0],\"revertChanges\"],null],[28,[37,4],[[30,0],\"saveChanges\"],null],[28,[37,4],[[30,0],\"showQuickScheduleWizard\"],null],[30,0,[\"socialProfile\"]]]],null],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[8,[39,6],null,[[\"@closeModal\",\"@errorMessage\",\"@sharePlan\"],[[28,[37,7],[[30,0],\"sharePlan\",null],null],[30,0,[\"errorMessage\"]],[30,0,[\"sharePlan\"]]]],null],[1,\"\\n\\n\"],[8,[39,8],null,[[\"@closeModal\",\"@currentAccount\",\"@showUpgradeModal\"],[[28,[37,7],[[30,0],\"showSharePlanUpgradeModal\",false],null],[30,0,[\"auth\",\"currentAccount\"]],[30,0,[\"shouldShowUpgradeModal\"]]]],null],[1,\"\\n\\n\"],[46,[28,[37,10],null,null],null,null,null]],[],false,[\"shared/context-nav\",\"unless\",\"t\",\"main\",\"action\",\"perform\",\"share-plan-modal\",\"set\",\"share-plan-upgrade-modal\",\"component\",\"-outlet\"]]",
    "moduleName": "preview-grid/templates/application.hbs",
    "isStrictMode": false
  });

  _exports.default = _default;
});